import { Stack, Typography } from '@mui/material'
import xor from 'lodash/xor'
import React, { useCallback, useState } from 'react'
import { Button, Icons } from 'utoniq-ui'

import {
  ResaleCreateQuery,
  UserItemSerialDetailFragment,
} from '@/clients/utoniq-core/schema'
import { TicketContainer } from '@/components/organisms'
import { useTranslation } from '@/core'
import { Cell } from '@/core/architecture'

type TicketQuantityFormProps = {
  onSubmit: (value: string[]) => void
  item: ResaleCreateQuery['item']
  serials: UserItemSerialDetailFragment[]
}

export const TicketQuantityForm: Cell<TicketQuantityFormProps> = ({
  item,
  onSubmit,
  serials,
}) => {
  const { t } = useTranslation('resaleCreate')
  const [selectedSerials, setSelectedSerials] = useState<string[]>([])

  const handleSelectSerial = useCallback((serialId: string) => {
    setSelectedSerials(prevState => xor(prevState, [serialId]))
  }, [])

  //整理番号が設定されているか判定
  const isTicketAdmission = !!item?.metadata?.ticket?.assignedNumberPrefix

  if (!serials.length) {
    return null
  }

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ bgcolor: 'grey.50', py: 2, px: 1 }}
      >
        <Icons.Ticket fontSize="small" sx={{ color: 'grey.600' }} />
        <Typography variant="h6" color="text.secondary">
          {t(
            isTicketAdmission
              ? 'selectTicketNumber'
              : 'selectTicketSerialNumber'
          )}
        </Typography>
      </Stack>
      <Stack spacing={2} sx={{ pt: 3, pb: 7 }}>
        <Typography variant="body2">
          {t(
            isTicketAdmission
              ? 'selectTicketNumberToSell'
              : 'selectTicketSerialNumberToSell'
          )}
        </Typography>
        <Stack>
          <TicketContainer
            serials={serials}
            selectedSerials={selectedSerials}
            onSelectSerial={handleSelectSerial}
          />
        </Stack>
      </Stack>
      <Stack alignItems="center" sx={{ pt: 3, pb: 7 }}>
        <Button
          type="submit"
          size="large"
          sx={{ width: 212 }}
          onClick={() => onSubmit(selectedSerials)}
          disabled={!item?.resaleEnabled || !selectedSerials.length}
        >
          {t('submit')}
        </Button>
      </Stack>
    </Stack>
  )
}
